import { Heading, Text, Button, Image } from '@bq/web-components';
import styles from './SolutionSection.module.css';

export function SolutionSection() {
  return (
    <section data-crd-id="r4.bq-solution-section" data-crd-layer="r4" className={styles.section} id="solution">
      <video
        className={styles.videoBg}
        autoPlay
        muted
        loop
        playsInline
        src="/assets/video/solution-bg.mp4"
      />
      <div className={styles.overlay} />
      <div className={styles.fadeTop} />
      <img
        className={styles.easterEgg}
        src="/assets/images/morpheus.png"
        alt=""
        aria-hidden="true"
      />
      <div className={styles.container}>
        <div className={styles.component}>
          <div className={styles.content}>
            <Heading level={3} as={2} color="s500">
              Ninja-Like Super Powers
            </Heading>
            <Heading level={2} as={1} color="n000">
              BlueQueue: the Red Pill
            </Heading>
            <Text size="r1" color="n000">
              BlueQueue is focused on a different way to do product development.
              It&apos;s not just about CodeGen. It&apos;s about a way to
              collaborate with each other and AI that drives personalized
              automation. We are relentless in our pursuit of eliminating wasted
              time and energies - no more.
            </Text>
            <Text size="r1" color="n000">
              Our main focus is to help every person, and the teams you&apos;re
              a part of, collaborate and achieve your product goals more
              efficiently and intelligently, while building a fun-supportive team
              culture.
            </Text>
            <Text size="r1" color="n000">
              &ldquo;There is a difference between knowing the path and walking
              the path.&rdquo;
            </Text>
            <div className={styles.ctas}>
              <Button variant="primary" href="#plan">
                Show Me
              </Button>
            </div>
          </div>
          <div className={styles.imageWrap}>
            <Image
              src="/assets/images/ninja-star-tps.png"
              alt="A blue ninja with a sword and throwing star saying. Enough TPS reports! I know Kung Fu!"
              className={styles.image}
            />
          </div>
        </div>
      </div>
      <div className={styles.fadeBottom} />
    </section>
  );
}
